import {
  IResearchIntakePreview,
  IResearchIntakeRequest,
} from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const previewResearchIntake = async (
  request: IResearchIntakeRequest
): Promise<IResearchIntakePreview> => {
  const response = await apiClient.post("/research/intake/preview", request);

  return response.data;
};
